module.exports = __webpack_public_path__ + "img/idle-icon.de5855d3.svg";